module.exports = __webpack_public_path__ + "img/cake-variant.5c46cd55.svg";